import { createUseStyles } from 'react-jss'
import { darkGrey } from '../../../../styles/const/colors'

const useStyles = createUseStyles({
  fieldWrapper: {
    marginTop: 16,
    width: '100%'
  },
  fieldLabel: {
    color: darkGrey,
    fontSize: 14,
    lineHeight: '17px',
    fontWeight: 700
  },
  fieldContent: {
    '& > *:first-child': {
      marginTop: [6, '!important'] // use important to override nested styles '.stepBody .field'
    }
  }
})

export default useStyles
